import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Popover, Col, Row, ProgressBar, Modal } from 'react-bootstrap';
import { Segment } from "semantic-ui-react";
import Amplify, { Storage, API, Auth } from 'aws-amplify';
import { TextField } from '@material-ui/core';
import { message, Upload, Space, Button, Drawer, Alert } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import NavBar from './NavBar'
import '../App.css';
import { useHistory, Link } from "react-router-dom";


export default function HomeUnauth() {

	const [open, setOpen] = useState(true);

	const onClose = () => {
		setOpen(false);
	};

	return (
		<div className="MyAll">
			
			<div className="MyNav">
				<Row >
					<Col></Col>
					<Col className="MyContainer1">
						<Row>
							<Col md={10}>
								<Navbar expand="lg" variant="dark" style={{ background: "inherited" }}>
									<Navbar.Brand href="/">AlphaFold2 TIB Server</Navbar.Brand>
									<Navbar.Toggle aria-controls="basic-navbar-nav" />

								</Navbar>
							</Col>
							<Col md={2}>
								<Navbar expand="lg" variant="dark" style={{ background: "inherited" }}>
									<Navbar.Collapse id="basic-navbar-nav">
										<Nav className="mr-auto">
											<Nav.Link href="/signin">Sign in</Nav.Link>
										</Nav>
									</Navbar.Collapse>
								</Navbar>
							</Col>
						</Row>

						<Segment basic >
							<h1 style={{ textAlign: "center", color: "white" }}><i>AlphaFold2 TIB Server</i></h1>
							<Segment basic>
								<h3 style={{ color: "white", textAlign: "justify" }}>AlphaFold v2.0 is a completely new model that was entered in CASP14 and published in Nature.It is widely regarded as a breakthrough milestone in predicting 3D structures of proteins using a Deep Neural Network approach. For simplicity, we refer to this model as AlphaFold throughout the rest of this document.</h3>
								<h3 style={{ color: "white", textAlign: "justify" }}>AlphaFold source code is publicly available earlier this month.  According to the official document, Alphafold was tested on Google Cloud with a machine using the nvidia-gpu-cloud-imagewith 12 vCPUs, 85 GB of RAM, a 100 GB boot disk, the databases on an additional 3 TB disk, and an A100 GPU. </h3>
								<h3 style={{ color: "white", textAlign: "justify" }}>After trying for quick a bit of time, we found that it is not easy to setup an enviorment to run AlphaFold. For example, downloading the data takes a loooooong time. To make the AlphaFold easy to use for TIB researchers, we have developed a serverless web platform for running AlphaFold.</h3>
							</Segment>
						</Segment>

						<Segment basic >
							<Segment basic >
								<div basic style={{ textAlign: 'center' }}>
									<h2 style={{ textAlign: "justify", color: "white", textShadow: "-2px -2px 4px #ffd700" }}>Notice: The AlphaFold2 TIB Server will not support compute service, please use <a href="https://sideways-fowl-fee.notion.site/d5748d969d054deeb8118e6f86226aeb?v=ab363dbc85904294b62434034a249e77" target='_blank' rel='noopener noreferrer'><b>TaiHang HPC service</b></a>. </h2>
								</div>
							</Segment>
						</Segment>
					</Col>
					<Col></Col>
				</Row>
			</div>
			<div style={{ height: "2em" }} />
			<div style={{ textAlign: "center" }}>
				<Button size='large' ghost onClick={() => window.location.href = "/signin"}>Login</Button>
			</div>
			{/* <div className="MyBody">
				<Row >
					<Col></Col>
					<Col className="MyContainer1">
						<Segment basic>
							<Form>
								<Segment secondary style={{ textAlign: "center", opacity: "0.7" }}>


									<div style={{ height: "1rem" }} />

									<Segment basic>
										<TextField
											error={sequenceError}
											id="outlined-multiline-static"
											label="Sequence(FASTA format)"
											multiline
											rows={6}
											fullWidth="true"
											// style={{width:"100%"}}
											placeholder={Sequence_eg}
											helperText={
												"Only single protein is accepted and the length should not exceed 1000aa.  If you have large protein or many proteins to fold, please contact Biodesign center."
											}
											variant="outlined"
											onChange={handleSequence}
											// onBlur={handleTest}
											disabled={disable1}
										/>
									</Segment>

									<Segment basic>
										<Space>
											<Upload {...props}>
												<Button icon={<UploadOutlined />} disabled={disable2} >{FileName === undefined ? "Click to Upload" : FileName}</Button>
											</Upload>

											<Button
												variant="primary"
												disabled={disable_submit}
												onClick={!isLoading ? handleSubmit : null}
											>
												{isLoading ? 'Submitting…' : 'Submit'}
											</Button>

											<Button variant="primary" href="https://alphafold2-prod.s3.amazonaws.com/result/102/result.zip" target="_blank">Example Output</Button>
										</Space>
									</Segment>
								</Segment>

							</Form>
						</Segment>
						<div style={{ height: "20px" }} />
					</Col>
					<Col></Col>
				</Row>
			</div> */}
			{/* <Drawer
				// title={<Typography.Text style={{textAlign:"center"}}></Typography.Text>}
				placement="top"
				// width={500}
				height={80}
				onClose={onClose}
				open={open}
				closable={false} 
				style={{opacity:0.8}}
			>
				<Row>
                    <Col flex="auto" />
                    <Col flex="1280px" style={{textAlign:"center"}}>
						<Space><Typography.Title level={5} style={{ textAlign: "justify", color:"red" }}>Notice: This website is now paid to use. <Button type='link' onClick={()=>setOpen(false)}>Close</Button></Typography.Title></Space>
                    </Col>
                    <Col flex="auto" />

                </Row>
			</Drawer> */}

			


		</div>
	)
}

